import React, { FunctionComponent } from 'react';
import { faIdCardAlt } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconAccount: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faIdCardAlt} />;

export { BrassIconAccount };
